import { registerCapability } from '../../platform/capability-registry';
import { ContainerStorageBlock } from './ContainerStorageBlock';
import { CONTAINER_STORAGE_ACTION_KEY_LIST, CONTAINER_STORAGE_FIELD_KEY_LIST } from './fieldKeys';
import { resolveContainerStoragePaths } from './resolvePaths';
import type { ContainerStorageBlockOptions } from './types';

registerCapability<ContainerStorageBlockOptions>({
  key: 'container-storage',
  fields: [...CONTAINER_STORAGE_FIELD_KEY_LIST],
  actions: [...CONTAINER_STORAGE_ACTION_KEY_LIST],
  component: ContainerStorageBlock,
  defaultPaths: (prefix) => resolveContainerStoragePaths(prefix),
  resolvePaths: (prefix, options) => resolveContainerStoragePaths(prefix, options),
});
